
class PollConstants {
    static TYPE_OPEN = "OPEN";
    static TYPE_SCORE = "SCORE";
    static TYPE_OPTIONS = "OPTIONS";
}


export default PollConstants;